import { useCallback } from "react";
import { TableColumn } from "@components/Table/TableColumns";
import { COMMON_NUM_COL_WIDTH } from "@core/constants";

export function useGetEmptyTableCells(suffix?: string) {
    return useCallback(
        (count: number): TableColumn[] => Array(count).fill(null).map((_, index) => ({
            key: `empty-cell-${index}-${suffix}`,
            head: '',
            headText: '',
            Value: () => null,
            style: {
                cell: {
                    flex: `0 0 ${COMMON_NUM_COL_WIDTH}`,
                    justifyContent: "center",
                    textAlign: "center",
                }
            },
        })),
        [suffix]
    );
}